
export default class PhoneNumber {

  private readonly e164Number: string;

  constructor(phoneNumber: string) {
    if ( !phoneNumber ) {
      throw new Error("Not a phone number.");
    }
    if ( phoneNumber.startsWith('+1') ) {
      phoneNumber = phoneNumber.substring(2);
    }
    if ( phoneNumber.length !== 10 ) {
      throw new Error("A US phone number should have 10 digits.");
    }
    if ( phoneNumber.match(/^(\d){10}$/) ) {
      this.e164Number = '+1' + phoneNumber;
    }
    else {
      throw new Error("A US phone number should have only 10 digits.");
    }
  }

  public getE164Number(): string {
    return this.e164Number;
  }

  public toString(): string {
    return this.e164Number;
  }

}
